/* eslint-disable react/prop-types */
import { Flex, Typography } from 'antd';

const SCORE_LABELS = {
  critical: 'Critical overall',
  bad: 'Bad overall',
  normal: 'Normal overall',
  good: 'Good overall',
  great: 'Great overall',
};

const SCORE_COLORS = {
  critical: '#CB2027',
  bad: '#F87C80',
  normal: '#FFDD99',
  good: '#7BE3AF',
  great: '#24D07A',
};

const FaceScanScore = ({ overall }) => {
  let score = '';
  switch (true) {
    case Number(overall) >= 80:
      score = 'great';
      break;
    case Number(overall) >= 60:
      score = 'good';
      break;
    case Number(overall) >= 40:
      score = 'normal';
      break;
    case Number(overall) >= 20:
      score = 'bad';
      break;
    default:
      score = 'critical';
      break;
  }
  return (
    <Flex align="center" style={{ gap: 8 }}>
      <div
        style={{
          width: 8,
          height: 8,
          borderRadius: 2,
          backgroundColor: SCORE_COLORS[score],
        }}
      />
      <Typography.Text type="secondary" style={{ lineHeight: '12px' }}>
        {SCORE_LABELS[score] || 'Unknown'}
      </Typography.Text>
    </Flex>
  );
};

export default FaceScanScore;
